import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  toEnglishNum,
  toPersianNum,
  toPureNum,
  toSeperatedNum,
} from "../../assets/utils";
import { setLoadWeight } from "../../redux/newRequest/newRequest.actions";
import { selectNewRequestLoadWeight } from "../../redux/newRequest/newRequest.selectors";
import { WeightStyled } from "./weight.styles";

const Weight = ({ setLoadWeight, selectNewRequestLoadWeight }) => {
  const handle_weight_change = (e) => {
    const value = toPureNum(e.currentTarget.value);
    setLoadWeight(toEnglishNum(value));
  };

  return (
    <WeightStyled>
      <div className="font-weight-bold ml-3">وزن‌بار</div>
      <div className="flex-grow-1 position-relative">
        <input
          onChange={(e) => handle_weight_change(e)}
          maxLength="7"
          type="text"
          className="w-100 weight-input"
          value={toSeperatedNum(toPersianNum(selectNewRequestLoadWeight))}
          inputMode="tel"
        />
        <div className="weight-kilo">کیلوگرم</div>
      </div>
    </WeightStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestLoadWeight: selectNewRequestLoadWeight,
});

const mapDispatchToProps = (dispatch) => ({
  setLoadWeight: (x) => dispatch(setLoadWeight(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Weight);
